import { Section } from "@/components/layout/section";

const STATS = [
  { value: "24/7", label: "Pantauan berkelanjutan" },
  { value: "< 60 dtk", label: "Respons laporan insiden" },
  { value: "100%", label: "Data terenkripsi & aman" },
  { value: "1.000+", label: "Warga terhubung (target)" },
];

export function SocialProof() {
  return (
    <Section>
      <div className="grid grid-cols-2 gap-6 rounded-2xl border border-border bg-surface-2 p-8 sm:grid-cols-4">
        {STATS.map((stat) => (
          <div key={stat.label} className="text-center">
            <div className="font-display text-3xl font-bold text-accent sm:text-4xl">
              {stat.value}
            </div>
            <div className="mt-2 text-sm text-text-muted">{stat.label}</div>
          </div>
        ))}
      </div>
    </Section>
  );
}
